"use client";

import React, { useContext } from 'react';
import ActionButton from '../../_util/ActionButton';
import { ModalContext } from '../context';
const ConfirmOkBtn = () => {
  const _useContext = useContext(ModalContext),
    autoFocusButton = _useContext.autoFocusButton,
    close = _useContext.close,
    isSilent = _useContext.isSilent,
    okButtonProps = _useContext.okButtonProps,
    rootPrefixCls = _useContext.rootPrefixCls,
    okTextLocale = _useContext.okTextLocale,
    okType = _useContext.okType,
    onConfirm = _useContext.onConfirm,
    onOk = _useContext.onOk;
  return /*#__PURE__*/React.createElement(ActionButton, {
    isSilent: isSilent,
    type: okType || 'primary',
    actionFn: onOk,
    close: function () {
      close === null || close === void 0 ? void 0 : close.apply(void 0, arguments);
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(true);
    },
    autoFocus: autoFocusButton === 'ok',
    buttonProps: okButtonProps,
    prefixCls: `${rootPrefixCls}-btn`
  }, okTextLocale);
};
export default ConfirmOkBtn;